import React, { Component } from 'react';
import UserContext from '../context/UserContext';
import Config from '../../Config';
import translate from '../i18next/i18next';

import '../../assets/css/agreement.css';

class Terms extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  renderContent = language => {
    return (
      <div className="page profile">
        <div className="main_content">
          <div className="agreement_container">
            <div className="agreement_title">
              {translate.t('termsTitle', { lng: language })}
            </div>
            <div className="terms-container">
              <iframe
                src={Config.termsOfUseUrl + language}
                title="Terms of Use"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return (
      <UserContext.Consumer>
        {({ language }) => this.renderContent(language)}
      </UserContext.Consumer>
    );
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/components/terms/Terms.js